/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-filename-extension */
import { assertIsDefined } from '@bingads-webui-campaign-react/debug-assert';
import { IColumn } from '@fluentui/react';
import { Model$ListingGroup } from '../ApiType';
import { odataMapOfListingGroupResponse } from '../ColumnOdataMap';
import { ListingGroupGridItemData } from '../interface';

// Not use '#', which will cause a lot of rerender
// eslint-disable-next-line no-script-url
export const anchorHrefPlaceholder = 'javascript:void(0)';
export const NOT_INTERACTIVE_PLACEHOLDER = '-';
export const NO_DATA_PLACEHOLDER_NONLEAF = '-';
export const NO_DATA_PLACEHOLDER_LEAF = '';

export const IsProductGroupBidLandscapeEnabled = (serverContext: any) => serverContext.Permissions.IsProductGroupBidLandscapeEnabled;
export const IsBidLessThan5CentsInShoppingCampaignEnabled = (serverContext: any) => serverContext.Permissions.IsBidLessThan5CentsInShoppingCampaignEnabled;
export const IsCurrentAccountInactive = (serverContext: any) => serverContext.CurrentAccountInActive;
export const IsReadOnlyMode = (serverContext: any) => serverContext.ReadOnlyMode;
export const showBidBoostValue = (itemData: ListingGroupGridItemData) => itemData.BidBoost && itemData.BidBoost.Multiplier != null;

export function shouldEnableEdit(enable: boolean, serverContext: any) {
  return !IsCurrentAccountInactive(serverContext) && !IsReadOnlyMode(serverContext) && enable;
}

export function getPropertyFromItemWithDefaultString(itemData: Model$ListingGroup | undefined, index: number | undefined, column: IColumn | undefined) {
  assertIsDefined(itemData);
  assertIsDefined(column);
  assertIsDefined(column.key);
  return itemData.IsLeaf ? getPropertyFromItem(itemData, index, column) || NO_DATA_PLACEHOLDER_LEAF : NO_DATA_PLACEHOLDER_NONLEAF;
}

export function getPropertyFromItem(itemData: Model$ListingGroup | undefined, index: number | undefined, column: IColumn | undefined) {
  assertIsDefined(column);
  assertIsDefined(column.key);
  return getPropertyFromItemByColumnKey(itemData, column.key);
}

export function getPropertyFromItemByColumnKey(itemData: Model$ListingGroup | undefined, columnKey: string) {
  const odataPathOfProperty = odataMapOfListingGroupResponse.get(columnKey);
  assertIsDefined(odataPathOfProperty);
  return getPropertyByPath(itemData, odataPathOfProperty);
}

// Format of property is like 'xx/yy/zz', then we get value from data.xx.yy.zz
export function getPropertyByPath(data: any, propertyPath: string) {
  const propertyPaths = propertyPath.split('/');
  return propertyPaths.reduce((obj, path) => (obj ? obj[path] : NO_DATA_PLACEHOLDER_NONLEAF), data);
}

export const getAccountCurrencyCode = serverContext => (serverContext && serverContext.CurrentAccount && serverContext.CurrentAccount.CurrencyCode) || 'USD';

export const offerLimitExceededWarning = i18n => i18n.getString(_TL_('Products data cannot be shown if your campaign targets more than 16 million products.'));
export const offerLimitExceededWarningForListingGroup = i18n => i18n.getString(_TL_('Product performance data cannot be displayed since your campaign targets exceed 16 million products. However, you can still create or edit a listing group.'));
